













import Vue from "vue";
import { mapActions, mapMutations } from "vuex";

export default Vue.extend({
  name: "Cards",
  components: {
    "farmer-list": () => import("./farmerList.vue"),
    "farmer-form": () => import("./farmerForm.vue"),
    "modal-history": () => import("./bonusPointHistory.vue"),
    "modal-spinResult": () => import("./farmerSpinResult.vue"),
    "modal-pickDayCSV": () => import("@/views/full/shared/pickDay_modal.vue"),
    "modal-upLoadPin": () => import("@/views/full/shared/updatePin_modal.vue")
  },
  data() {
    return {
      loadDone: true
    };
  },
  methods: {
    ...mapActions({
      getFarmers: "farmer/getFarmers",
      checkShowMenu: "menu/checkShowMenu"
    }),
    ...mapMutations({ resetQuery: "farmer/resetQuery" })
  },
  async created() {
    const res = await this.checkShowMenu(this.$route.fullPath);
    if (!res) this.$router.push({ name: "permissionDenied" });
    this.resetQuery();
    this.getFarmers();
  }
});
